import { Directive, OnInit, OnDestroy, AfterViewInit, Renderer2, ElementRef, Input, Injector, NgZone, HostBinding} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import {ColumnData} from '../../model/column.model';
import { FPreviewEditorService } from '../../service';

@Directive({
    selector: 'preview-base-editor',
})
export class PreviewBaseEditorDirective implements OnInit, OnDestroy, AfterViewInit {

    @Input() placeholder = '';
    // 组件高度
    @Input() height = '';
    controlId: string;
    type: string;
    options: any = {};
    group: FormGroup;
    column: ColumnData;
    formControl: FormControl;
    rowIndex=-1;
    rowId='';
    inputElement: any;
    /** 是否正在向server 发送请求 */
    pending = false;

    /** 禁止事件冒泡 */
    stopPropagation = true;
    /** 默认焦点 */
    focus = true;

    private clickEvent: any;
    private mouseDownEvent: any;
    private mouseUpEvent: any;
    private dblClickEvent: any;
    
    validators = [];

    ngZone: NgZone;
    private _inputKeydown = null;

    _editorClickEvent: MouseEvent = null;
    @HostBinding('class') cls = 'upload-and-preview--editor';
    @HostBinding('style.width') width = '100%';
    previewSer: FPreviewEditorService;
    private focusTimer = null;
    constructor(public render: Renderer2, public el: ElementRef, public injector: Injector) {
        this.ngZone = this.injector.get(NgZone);
        this.previewSer = this.injector.get(FPreviewEditorService,null);
    }

    ngOnInit(): void {

        if (this.column && this.column.editor) {
            this.options = this.column.editor.options;
            this.validators = this.column.editor.validators || [];

            // 启用任意输入后，字符最大长度属性值验证
            // 当maxLength <= 0 时认为此属性无效
            if (this.options && this.options.nosearch !== undefined && this.options.nosearch) {
                if ( this.options.maxLength !== undefined && this.options.maxLength <= 0) {
                    this.options.maxLength = undefined;
                }
            }
        }

        this.clickEvent = this.render.listen(this.el.nativeElement, 'click', (e: MouseEvent) => {
            e.stopPropagation();         
        });

        this.mouseDownEvent = this.render.listen(this.el.nativeElement, 'mousedown', (e: MouseEvent) => {
            this._editorClickEvent = e;
        });

        this.mouseUpEvent = this.render.listen(this.el.nativeElement, 'mouseup', (e: MouseEvent) => {
            this._editorClickEvent = null;
        });


        if (this.group) {
            this.formControl = this.group.controls[this.column.field] as FormControl;
        }
        // this.dblClickEvent = this.render.listen(this.el.nativeElement, 'dblclick', (e: MouseEvent) => {
        //     e.stopPropagation();
        //     e.preventDefault();
        // });

    }

    ngAfterViewInit() {
        //this.setFocus();
        // if (this['instance']) {
        //     this['instance'].inDatagrid = true;
        // }

        this._inputKeydown =  this.render.listen(this.inputElement, 'keydown', (e) => {
            if (e.ctrlKey || e.shiftKey) {
                e.stopPropagation();
            }
        });

        if (this.formControl) {
            this.formControl.valueChanges.subscribe( (val: any) => {
                if(!this.formControl.pristine){
                    const changeData = { [this.column['field']]: val, 'id':this.rowId,'column':this.column};
                    this.previewSer.editValueChange.emit(changeData);
                  //  this.setErrorMessage();
                }               
            });
        }
    }

    ngOnDestroy() {
        if (this.clickEvent) {
            this.clickEvent();
        }
        if (this.dblClickEvent) {
            this.dblClickEvent();
        }

        if (this.mouseDownEvent) {
            this.mouseDownEvent();
        }
        if (this.mouseUpEvent) {
            this.mouseUpEvent();
        }
        if (this._inputKeydown) {
            this._inputKeydown();
            this._inputKeydown = null;
            this.inputElement = null;
        }

    }

    /**
     * 不需要聚焦
     * @returns 
     */
    private setFocus() {
        if (!this.focus) {
            return;
        }

        if (this.ngZone) {
            this.ngZone.runOutsideAngular(() => {
                if (this.focusTimer) {
                    clearTimeout(this.focusTimer);
                }
                this.focusTimer = setTimeout(() => {
                    if (this.inputElement) {
                            this.inputElement.focus();                        
                    }
                }, 10);
            });
        }
    }


    eventParams = ($event) => {
        let rowData = null;
        let rowId = null;
        if (this.previewSer&&this.rowIndex>-1) {
            rowData = this.previewSer.getRowData(this.rowIndex);           
                rowId=this.rowId;
        }

        return {
            rowData,
            rowId,
            value: $event,
            form: this.group,
            formControl: this.formControl
        };
    }

    onValueChange($event) {
        if (this.options.valueChange) {
            this.options.valueChange(this.eventParams($event));
        }
    }
}